import type { PlatformOSType } from "react-native";

/**
 * Chooses ViewJob's OneGraph vs servlet REST data path.
 *
 * On web, an explicit `forceOneGraph` wins over Apollo SSR detection so a REST
 * embed can opt out even when `apolloClient` / `window.__APOLLO_STATE__` is
 * present. When the prop is unset, Apollo-SSR'd pages stay on OneGraph and
 * other web entries stay on REST. Native ignores the prop and gates on
 * `rn_viewjob_onegraph_tst` buckets 2 and 3.
 */
export function shouldUseOneGraphDataPath({
  platformOS,
  forceOneGraph,
  isApolloDriven,
  oneGraphAllocationValue,
}: {
  platformOS: PlatformOSType;
  forceOneGraph: boolean | undefined;
  isApolloDriven: boolean;
  oneGraphAllocationValue: number;
}): boolean {
  if (platformOS === "web") {
    return forceOneGraph !== undefined ? forceOneGraph : isApolloDriven;
  }
  return oneGraphAllocationValue === 2 || oneGraphAllocationValue === 3;
}
